export * from '../src/composites/wui-list-social/index.js';
//# sourceMappingURL=wui-list-social.js.map